const styles = theme => ({

    nomText: {
        color: '#FFF ! important',
        fontFamily: 'cardiuma-M ! important',
        fontSize: '34px ! important',
        fontStyle: 'normal',
        fontWeight: '500 ! important',
        lineHeight: '20px ! important'
    },

    fnoFormDateField: {
    display: 'flex',
    // marginTop: '25px',
    // marginRight: '20px',
    // marginBottom: '10px'
},

datePickerWrapper: {
    marginLeft: '10px'
},

datePicker: {
    width: '190px',
    backgroundColor: '#131E2E ! important',

    '& .MuiInputBase-root': {
        color: '#fff ! important',
        height: '40px',
        padding: '6px 10px',
    },
    '& .MuiInputLabel-root': {
        color: '#fff ! important',
        fontFamily: 'cardiuma-regular',
        fontSize: '14px',
        fontStyle: 'normal',
    },
    '& .MuiSvgIcon-root': {
        color: '#fff ! important',
    },

    "@media only screen and (max-width: 1620px)": {
        width: '190px !important'
    },
    "@media only screen and (max-width: 1420px)": {
        width: '180px !important'
    },
    "@media only screen and (max-width: 1350px)": {
        width: '170px !important'
    },
},

inputColor: {
    color: '#ffffff !important',
    fontFamily: 'cardiuma-regular ! important',
    fontSize: '14px ! important',
    fontWeight: 500
},

select: {
    color: '#ffffff !important',
    width: '160px !important',
    fontFamily: 'cardiuma-regular ! important',
    background: '#131E2E',
},

intSelText: {
    color: '#000 !important',
    fontFamily: 'cardiuma-M ! important',
    fontSize: '14px ! important',
    fontWeight: 500
},

horizantalTablayout: {
        width: '99% !important',
        borderRadius: '15px !important',
        background: '#131E2E !important',
    },

customDataGrid: {
        '& .MuiDataGrid-columnHeaders': {
            color: '#747474 !important',
            fontFamily: 'cardiuma-M ! important',
            fontSize: '14px ! important',
            fontWeight: '600 ! important',
            lineHeight: '18px ! important'
        },

        '& .MuiDataGrid-cell': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '14px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
            borderBottom: '1.5px solid black ! important',
        },

        "& .MuiDataGrid-menuIconButton": {
            opacity: 1,
            color: "#fff ! important"
        },

        "& .MuiDataGrid-sortIcon": {
            opacity: 1,
            color: "#fff ! important",
        },

        '& .MuiDataGrid-withBorderColor': {
            borderColor: "none !important"
        },

        '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select, & .MuiTablePagination-actions': {
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '13px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiSelect-icon': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-footerContainer': {
            border: 'none ! important',
        },

        '& .MuiDataGrid-overlay': {
            backgroundColor: '#131E2E ! important',
            color: '#fff ! important',
            fontFamily: 'cardiuma-regular ! important',
            fontSize: '14px  ! important',
            fontStyle: 'normal',
            fontWeight: '400  ! important',
        },

        '& .MuiSvgIcon-root': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-filterIcon': {
            color: '#fff ! important',
        },

        '& .MuiDataGrid-selectedRowCount': {
            color: '#fff',
        }

    },

    edtIcnClr:{
        color: '#edd682 !important',
        '& .MuiSvgIcon-root': {
            color: '#edd682 !important',
        }
    }



})

export default styles